import clsx from 'clsx'
import i18n from 'src/i18n'
import { IMAGES } from 'src/assets'
import { LiveStatus } from 'src/pages/CommunityDetails/Posts/live'
import { ImageWrapper, Label, Wrapper } from './liveCard.styles'
import { LiveCardProps } from './liveCard.types'
import LiveIcon from './assets/live.svg'

const LiveCard = ({ post, className }: LiveCardProps) => {
  const src = post.live?.thumbnail || IMAGES.LIVE_POST_IMG

  return (
    <Wrapper
      href={post?.live?.link}
      title={post?.live?.title}
      target="_blank"
      rel="noreferrer noopener nofollow"
      className={clsx(
        className,
        '_d-flex _align-items-center _justify-content-between _border _border-gray-200 _rounded-lg _bg-gray-100 _text-gray-900 _overflow-hidden'
      )}
    >
      <ImageWrapper className="_flex-shrink-0">
        <img className="_w-full _h-full" src={src} alt={post?.live?.title} loading="lazy" />
      </ImageWrapper>

      {post?.live?.status === LiveStatus.STARTED && (
        <div className="_d-flex _align-items-center _justify-content-center _justify-content-md-end _p-4 _p-md-6">
          <Label className="_d-flex _align-items-center _justify-content-center _p-1 _font-14 _text-green-lighter _rounded">
            <img src={LiveIcon} alt={i18n.t('feed.live.happening_now')} loading="lazy" />
            {i18n.t('feed.live.happening_now')}
          </Label>
        </div>
      )}
    </Wrapper>
  )
}

export default LiveCard
